import { createFileRoute } from '@tanstack/react-router';
import { EvaluationTypeIcon } from '@/app/components/features/evaluations/EvaluationTypeIcon';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbMenu,
  BreadcrumbMenuItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/app/ui/components/breadcrumb';
import {
  Header,
  HeaderSidechatButton,
  HeaderBackButton,
  HeaderSidebarTrigger,
} from '@/app/ui/components/header';
import { EvaluationTypeLabelsEnum } from '@/app/utils/constants';
import { CheckListIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useTranslations } from 'use-intl';
import { ProjectTypeIcon } from '@/app/components/features/projects/ProjectTypeIcon';
import { getProjectDetailsQuery } from '@/app/hooks/queries/useProjects';
import { getEPADetailsQuery } from '@/app/hooks/queries/useEarlyPhaseAssessment';
import { DependenciesPageContent } from '@/app/components/features/evaluations/Dependencies/DependenciesPageContent';
import { useSuspenseQuery } from '@tanstack/react-query';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/early-phase-assessments/$earlyPhaseAssessmentId/_layout/(main)/dependencies/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations('pages.epaHome');
  const tFeature = useTranslations('features.dependencies');
  const { earlyPhaseAssessmentId, projectId } = Route.useParams();
  const { data: project } = useSuspenseQuery(getProjectDetailsQuery(projectId));
  const { data: evaluation } = useSuspenseQuery(getEPADetailsQuery(earlyPhaseAssessmentId));

  return (
    <>
      <Header>
        <HeaderBackButton />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbMenu>
              <BreadcrumbMenuItem to="/project/$projectId" params={{ projectId }}>
                <ProjectTypeIcon type={project.type} />
                {project.name}
              </BreadcrumbMenuItem>
            </BreadcrumbMenu>
            <BreadcrumbSeparator className="max-md:hidden" />
            <BreadcrumbItem>
              <BreadcrumbLink
                to="/project/$projectId/early-phase-assessments/$earlyPhaseAssessmentId"
                params={{ projectId, earlyPhaseAssessmentId }}
              >
                <EvaluationTypeIcon type={EvaluationTypeLabelsEnum.EARLY_PHASE_ASSESSMENT} />
                <span className="line-clamp-1">{evaluation.name}</span>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem className="max-md:hidden">
              <BreadcrumbLink
                to="/project/$projectId/early-phase-assessments/$earlyPhaseAssessmentId"
                params={{ projectId, earlyPhaseAssessmentId }}
              >
                <HugeiconsIcon icon={CheckListIcon} />
                {t('title')}
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="max-md:hidden" />
            <BreadcrumbItem>
              <BreadcrumbPage>{tFeature('title')}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <HeaderSidechatButton />
      </Header>
      <DependenciesPageContent />
    </>
  );
}
